export const cardBody = {
    width: "200px",
    height: "200px",
    border: "1px solid black",
    padding: "5px",
    cursor: "pointer"
};

export const cardType = {
    height: "25px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
};

export const cardPicture = {
    height: "125px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
};

export const cardText = {
    height: "50px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
};

export const image = {
    width: "100px",
    height: "100px"
};

export const typeImage = {
    width: "20px",
    height: "20px"
};

export const albumImage1 = {
    position: "absolute"
};

export const albumImage2 = {
    width: "130px",
    height: "130px",
    position: "absolute",
    top: "10px",
    left: "10px"
};
